<div class="flxClmn bs-enabled" style="padding: 0 2vw; max-width: 1700px; margin: auto; width: 100%;">
	<div class="page-title-container flxClmn-center">
		<div class="page-title-inner-container flxRow">
			<span class="page-title">Training Videos</span>
		</div>
		<div class="page-subtitle-container">
			<span class="page-subtitle">
				Short videos to get the most out of Trustifi
			</span>
		</div>
	</div>

	<div class="page-inner-content-holder no-scroll flxClmn vSpace2">
		<div class="flxRow f-1-0 gap-4 overflow-auto" style="font-size: 14px;">

			<!-- TOC sidebar -->
			<div class="p-4 flex-column gap-4 fw-bold flex-shrink-0" style="flex-basis: 280px; position: sticky; top: 20px; font-size: 16px;">
				<span *ngFor="let group of videosByCategory"
					  class="p-3 cursor-pointer text-nowrap animated fadeIn"
					  style="transition: color 1s, font-weight 0.2s; user-select: none;"
					  [style.color]="getLabelColor(group.category)"
					  [style.fontWeight]="activeCategory === group.category ? '600' : '400'"
					  (click)="scrollToSection(group.category)">
					{{group.category}}
				</span>
			</div>

			<!-- Main content -->
			<div class="flex-column f-1-0 gap-3 overflow-auto">
				<div class="flex-row justify-content-between align-items-center" >
					<search-box [(model)]="searchVideoTxt"
								(modelChange)="searchVideo()"
								placeholder="Search videos"
								style="width: 33%; min-width: 250px;">
					</search-box>
				</div>

				<!--Gallery: groups by category-->
				<div class="flex-column f-1-0 gap-3 overflow-auto" *ngIf="videosByCategory?.length" #scrollContainer>
					<ng-container *ngFor="let group of videosByCategory">
						<div class="flex-column p-3 border bg-light flex-shrink-0 animated fadeIn" [attr.id]="sectionId(group.category)" style="min-height: 280px; --bs-border-style: dashed;">
							<div class="flex-column gap-3 animated fadeIn">
								<h5 class="fw-bolder">{{group.category}}</h5>
								<div class="w-100" style="display: grid; grid-gap: 1rem; grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));">
									<div style="height: 270px; max-width: 325px;" *ngFor="let video of group.videos">
										<div class="border rounded-3 bg-white overflow-hidden flex-column h-100 position-relative cursor-pointer hvr-opacity shadow-sm"
											 (click)="openVideo(video); $event.stopPropagation();">
											<div class="d-flex centralize border-bottom h-75 position-relative" style="background: url('images/material-placeholder-bg.png'); background-size: 157%; background-position: center center; filter: contrast(1.1);">
												<img class="h-100 w-100" style="object-fit: cover; object-position: center;"
													 [src]="video.thumbnail" alt="">
												<i class="far fa-play-circle position-absolute" style="font-size: 3.5rem; color: white; opacity: 0.85; text-shadow: 0 2px 8px rgba(0,0,0,0.5);"></i>
											</div>
											<div class="p-2 flex-row align-items-center gap-1">
												<span class="fw-bold f-1-0 ellipsis" style="font-size: 13px;" [tooltip]="video.title">{{video.title}}</span>
												<i *ngIf="showCopyLink" class="far flex-shrink-0 hvr-opacity" style="font-size: 14px; padding: 4px; color: #6c757d;"
												   [ngClass]="video.copied ? 'fa-check text-success' : 'fa-link'"
												   [tooltip]="'Copy video link'"
												   (click)="copyVideoLink(video, $event)"></i>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ng-container>
				</div>

				<!--Empty state when search has no results-->
				<div class="flex-column f-1-0 centralize p-5 animated fadeIn" *ngIf="!visibleVideoCount">
					<i class="fas fa-search text-muted" style="font-size: 3rem; opacity: 0.4;"></i>
					<span class="text-muted mt-3">No videos match your search</span>
				</div>
			</div>
		</div>
	</div>
</div>

<!--Video player popup-->
<popup-c class="bs-enabled" *ngIf="currentVideo"
		 [head]="currentVideo.title" size="large"
		 (closeCb)="closeVideo()"
		 [buttons]="{cancel: 'Close'}">
	<div class="flex-column f-1-0" style="overflow: hidden;">
		<div class="flex-column f-1-0 position-relative" style="background: black;">
			<iframe [src]="currentVideoIframeUrl"
					class="f-1-0" style="border: none;"
					allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
					allowfullscreen="true">
			</iframe>
		</div>
	</div>
</popup-c>
